'use strict'

// Pure classification helpers for refine-planner drag moves.
// Kept dependency-free so they're trivially unit-testable and reusable.

export const isBiWeeklyStop = (stop = {}) => {
  const code = String(stop.frequencyCode || '').trim().toUpperCase()
  return stop.scheduleKind === 'biweekly' || code === 'BW' || code === 'BW_A' || code === 'BW_B'
}

export const isWeeklyStop = (stop = {}) => {
  if (isBiWeeklyStop(stop)) return false
  const code = String(stop.frequencyCode || '').trim().toUpperCase()
  const frequency = String(stop.frequency || '').trim().toLowerCase()
  return stop.scheduleKind === 'weekly' || code === 'W' || code === 'WK' || code === 'WEEKLY' || frequency === 'weekly'
}

const DAY_BUCKET_RE = /^([AB]):(.+)$/

const parseDayBucketKey = (key) => {
  const match = DAY_BUCKET_RE.exec(String(key || ''))
  if (!match) return null
  return { weekType: match[1], dayOfWeek: match[2] }
}

// A weekly property occurs EVERY week, so it has no single week type — it lives
// in both the A and B columns. Dragging it from A:Day to B:SameDay therefore
// changes nothing: the server can't store a week for it, analyze re-derives it
// into both weeks, and the optimistic move visually reverts. Such a pure
// week-flip is a no-op and should be blocked at drop time. Day changes (even
// across weeks) remain valid and flow through the normal "apply to both weeks"
// path. Bi-weekly stops genuinely belong to one week, so their A<->B drags are
// real schedule changes and are always allowed.
//
// Returns 'block' or 'allow'.
export const classifyWeeklyWeekMove = (stop, sourceKey, targetKey) => {
  if (!isWeeklyStop(stop)) return 'allow'
  const source = parseDayBucketKey(sourceKey)
  const target = parseDayBucketKey(targetKey)
  // Either end is unscheduled/unassigned (no A:/B: prefix) → not a week flip.
  if (!source || !target) return 'allow'
  if (source.dayOfWeek !== target.dayOfWeek) return 'allow'
  // Same day, different week, weekly property → no-op week flip.
  if (source.weekType !== target.weekType) return 'block'
  return 'allow'
}
